export default {
  form: {
    first_name: {
      label: 'Nome próprio',
    },
    last_name: {
      label: 'Apelido',
    },
    email: {
      label: 'E-mail',
    },
    phone_number: {
      label: 'Número de telefone',
    },
    birthday: {
      label: 'Data de nascimento',
    },
    city: {
      label: 'Cidade',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    success: 'Perfil atualizado com sucesso',
    error: 'Falha ao atualizar o perfil',
  },
};
